import axios from './../../api';
import Constants from '../../constants';

export default {
  namespaced: true,

  state: {
    listNeopassModulesPages: [],
    listPermissions: [],


    messageHeader: null,
    saving: false,
    errors: [],
  },
  getters:{
    listNeopassModulesPages(state){
      return state.listNeopassModulesPages;
    },

    listPermissions(state){
      return state.listPermissions;
    },

    messageHeader(state){
      return state.messageHeader;
    },



    saving(state){
      return state.saving;
    },

    errors(state){
      return state.errors;
    }
  },
  mutations: {
    SET_LISTNEOPASSMODULESPAGES(state, modules){
      state.listNeopassModulesPages = modules;
    },

    SET_LISTPERMISSIONS(state, list){
      state.listPermissions = list;
    },

    SET_MESSAGEHEADER(state, msg){
      state.messageHeader = msg;
    },



    SET_SAVING(state, bool){
      state.saving = bool;
    },

    SET_ERRORS(state, err){
      state.errors = err;
    },
  },
  actions:{
    /**
         * Load all informations of modules and pages in Neopass
         * @param {*} context
         */
    async loadModulesPages(context){
      console.log('wait...loadModulesPages');

      await axios.get('/api/modules/getModulesPages/neopass/0').then((response) => {
        context.commit('SET_LISTNEOPASSMODULESPAGES', response.data);
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });
    },

    /**
         * Load all permissions existing in Neopass
         * @param {*} context
         */
    async loadPermissions(context){
      console.log('wait...loadPermissions');

      await axios.get('/api/permissions/getAllPermissions').then((response) => {
        let list = response.data.filter(p => p.module != Constants.MODULE_NEOPASS_FORM);
        context.commit('SET_LISTPERMISSIONS', list);
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });
    },

    /**
         * initialize all informations when the page load
         * @param {*} context
         */
    async loadingDatas(context){
      await context.dispatch('loadModulesPages');
      await context.dispatch('loadPermissions');
    }
  },
};
